import * as PEOPLE_API from '@/api/people'

export default {
  state: {
    peopleList: {},
    peopleInfo: {},
    peopleItem: ""
  },
  getters: {
    peopleList: state => state.peopleList,
    peopleInfo: state => state.peopleInfo
  },
  mutations: {
    setPeopleList (state, payload) {
      state.peopleList = payload
    },
    setPeople (state, payload) {
      state.peopleInfo = payload
    },
    deletePeople (state, id) {
      delete state.peopleList.data[id]
    },
    updatePeople (state, payload) {
      state.peopleInfo = payload
    },
    syncPeople (state, payload) {
      state.peopleItem = payload
    }
  },
  actions: {
    getPeopleList ({ commit }, params) {
      return PEOPLE_API.getAllPeople(params).then(response => {
        commit('setPeopleList', response.data)
        return response
      })
    },
    getPeople({ commit }, id) {
      return PEOPLE_API.getPeople(id).then(response => {
        commit('setPeople', response.data)
        return response
      })
    },
    updatePeople({ commit }, { id, payload }) {
      return PEOPLE_API.updatePeople(id, payload).then(response => {
        commit('updatePeople', response.data)
        return response
      })
    },
    deletePeople({ commit }, id) {
      return PEOPLE_API.deletePeople(id).then(response => {
        commit('deletePeople', id)
        return response
      })
    },
    createPeople({ commit }, payload) {
      return PEOPLE_API.createPeople(payload).then(response => {
        commit('setPeople', response.data)
        return response
      })
    },
    syncPeople({ commit }) {
      return PEOPLE_API.syncPeople().then(response => {
        commit('syncPeople', response.data)
        console.log(response.data)
        return response
      })
    }
  }
}
